var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSizeicon = function SvgTextSizeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 11.551a.5.5 0 0 0 .468.322h1.342l.604 1.787a.5.5 0 0 0 .474.34h.536a.5.5 0 0 0 .467-.678l-3.429-9A.5.5 0 0 0 11.8 4h-.646a.5.5 0 0 0-.467.322l-.75 1.969a.5.5 0 0 0 0 .356l.51 1.338a.2.2 0 0 0 .373 0l.657-1.724 1.594 4.184h-1.252a.3.3 0 0 0-.28.406l.266.7ZM3.187 9.644l2.368-6.216 2.369 6.216H3.187Zm-.584 1.534-.944 2.499A.5.5 0 0 1 1.19 14h-.87a.3.3 0 0 1-.28-.407L4.716 1.322A.5.5 0 0 1 5.183 1h.745a.5.5 0 0 1 .467.322l4.675 12.271a.3.3 0 0 1-.28.407H10a.5.5 0 0 1-.463-.31l-1.03-2.512H2.604Z",
    clipRule: "evenodd"
  })));
};
export default SvgTextSizeicon;